import { styled } from 'styled-components';
import { CustomContainer } from '../customContainer/CustomContainer';

export const IntroContainer = styled(CustomContainer)`
    white-space: pre-line;
    @media screen and (min-width: 768px) {
        padding: 64px 24px;
    }
`;
